/** Loading-convention helpers (spec §3.4). */

/** Clamp/snap the AMI fleet-median coincident kW/meter to the Avg Demand
 *  slider's 1-15 kW range and 0.5 kW step. Returns null when no usable
 *  median is available (caller keeps the flat 5.0 default). */
export function calibratedAvgDemandKw(median: number | null | undefined): number | null {
  if (median == null || !Number.isFinite(median) || median <= 0) return null
  const snapped = Math.round(median * 2) / 2
  return Math.min(15, Math.max(1, snapped))
}
